module.exports = __webpack_public_path__ + "static/media/logo-1.d878d690.png";